import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class CardListDetailMixin extends Vue {
  @Prop({ required: true })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  data!: any[];

  @Prop({ required: false, default: false })
  loading!: boolean;

  /** Property for parent component to bind to for selected item information
   *  This property can be used for the following:
   *    Closing the selected detail card by setting the property to null
   *    Using properties on the selected item for printing a report
   */
  @Prop({ required: false })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  externalSelectedItem!: any | null;

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  selectedItemBacking: any | null = null;

  /** Array of paged data to limit data bound to lists displayed on UI to prevent performance degredation from large datasets. */
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  pagedData = [] as any[];

  /** Array to store data as it's updated with data from api from the user browsing layer to layer.
   *  Card List Detail component using this mixin must watch for changes to selectedItem and manually update this array.
   */
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  cachedData = [] as any[];

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  get selectedItem(): any | null {
    return this.selectedItemBacking;
  }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  set selectedItem(item: any | null) {
    this.selectedItemBacking = item;
    this.$emit("update:externalSelectedItem", item);
  }

  /** Default for setting selected item when not using cachedData array.
   *  Override this method in the Card List Detail component using this mixin when using the cachedData array.
   *  The override method should find the selected item in the cachedData array and set it as the new selectedItem.
   */
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setSelectedItem(item: any | null): void {
    this.selectedItem = item;
  }

  @Watch("data")
  dataChanged() {
    this.selectedItem = null;
    this.cachedData = [...this.data];
  }

  /** Used by the parent to close the selected detail card by setting to null */
  @Watch("externalSelectedItem")
  externalSelectedItemChanged(): void {
    this.selectedItemBacking = this.externalSelectedItem;
  }
}
